import React, { useState, useEffect, useCallback } from 'react';

import {
    requestUploadSlotV2,
    requestUploadSlotV1
} from '@helpers/file-upload-helpers';

export const performFileUpload = (
    xhr,
    file, 
    url, 
    params,
    onProgress = (e) => {}
) => new Promise(
    (resolve, reject) => {
        var formData = new FormData();
    
        var fields = params ? params : {};
    
        for(var x in fields) {
            formData.append(
                x,
                fields[x]
            );
        }
    
        formData.append('file', file);
    
        xhr.upload.addEventListener('progress', onProgress);
        xhr.addEventListener('loadend', resolve);
        xhr.addEventListener('error', reject);

        xhr.open('POST', url, true);
        xhr.send(formData);
    }
);

const useFileUpload = ({
        fileSize = 1024 * 1024 * 80, //80mb max.
        accepts = ['*'],
        version = 'v2',
        immediate = false, //if set to true will upload as soon as a file is in queue
        onProgress = (e) => {},
        onComplete = () => {},
        onError = ({message}) => {},
        getUploadParams = async () => ({}),
        fileProp,
        extraData = {},
        getUploadURL = async () => {
            switch(version) {
                case 'v1':
                    return await requestUploadSlotV1(window.location.toString(), {}).then((url) => ({url}))
                case 'v2':
                    const uploadParams = {
                        ...(await getUploadParams()),
                        fileName: fileProp.name,
                        extra: extraData
                    };
                    return await requestUploadSlotV2(
                        window.location.toString(),
                        uploadParams
                    ).then( (o) => {
                        console.log(`v2`, o);
                        return o;
                    });
            }
        },
        ...props
    }) => {

    const [isUploading, setIsUploading] = useState(false);
    const [error, setError] = useState(null);
    const [file, setFile] = useState(fileProp);
    const [xhrRequest, setXhrRequest] = useState(null);

    useEffect(
        () => {
            if(error === null) return;
            if(onError) onError({message: error});
        },
        [error]
    )

    const abort = useCallback(
        () => {
            if(xhrRequest) {
                xhrRequest.abort();
                setXhrRequest(null);
            }
        },
        [xhrRequest]
    )

    const reset = useCallback(() => {
        setError(null);
        setIsUploading(false);
        setFile(null);
    })

    const beginUpload = useCallback(() => {
        if(file === null) {
            setError('No file has been added.');
            setIsUploading(false);
            return;
        }
        setError(null);
        setIsUploading(true);

        const run = async () => {
            const uploadURLPayload = await getUploadURL();
            const xhr = new XMLHttpRequest();
            performFileUpload(
                xhr,
                file,
                uploadURLPayload.url,
                uploadURLPayload.fields ?? {},
                onProgress
            ).then(() => {
                onComplete(
                    uploadURLPayload
                );
            }).catch((e) => {
                setError(e)
            });

            setXhrRequest(xhr);
        }

        run();
    }, [file]);

    return {
        beginUpload,
        isUploading,
        error,
        reset,
        abort
    }
}

export default useFileUpload;